import type { TeamDispatch } from 'features/TeamChat/api/teamChat.api'
import {
  applyTeamMessage,
  applyTeamRequest,
  scheduleSummaryRefresh,
} from 'features/TeamChat/api/teamChat.cache'
import {
  forReceiverMessage,
  forReceiverRequest,
  isTeamMessage,
  isTeamRequest,
} from 'features/TeamChat/api/teamChat.transform'

const field = (payload: unknown, key: string): unknown =>
  typeof payload === 'object' && payload !== null
    ? (payload as Record<string, unknown>)[key]
    : undefined

export const handleMessageSent = (payload: unknown, meId: number) => (dispatch: TeamDispatch) => {
  const message = field(payload, 'message')
  if (!isTeamMessage(message)) return
  dispatch(applyTeamMessage(forReceiverMessage(message, meId)))
  dispatch(scheduleSummaryRefresh())
}

export const handleRequestChanged =
  (payload: unknown, meId: number) => (dispatch: TeamDispatch) => {
    const request = field(payload, 'request')
    const line = field(payload, 'event_message')
    if (!isTeamRequest(request)) return
    dispatch(applyTeamRequest(forReceiverRequest(request, meId)))
    if (isTeamMessage(line)) dispatch(applyTeamMessage(forReceiverMessage(line, meId)))
    dispatch(scheduleSummaryRefresh())
  }
